import { ApiEndpoints } from "../core";
import { httpClient } from "../core";
import {  changeScheduleLoading, dispatch, setErrorMessage, setGymScheduleState } from "../redux";

export const getScheduleGym = async (refresh = false, page,limit,search="",sort)=> {
    try {
      // Set Loading if it is not refresh
      if (!refresh)    dispatch(changeScheduleLoading(true));
  
  
      // API Fetching
      const resp = await httpClient().get(ApiEndpoints.getScheduleGym, {
        params: {
          page,
          limit,
          search,
          sort,  
        },
      });
  
      // Handle Error
      if (resp.status > 201 || !resp.data.success) {
        throw new Error(resp.data.message);
      }
  
      // Update to Store
      dispatch(setGymScheduleState({ gymSchedule: resp.data.results, refresh }));
  
      // dispatch(setSuccessMessage(resp.data.message));
      return resp.data.results;
    } catch (error) {
      // Set Error message to store
      dispatch(setErrorMessage(error.message ?? "Error happended"));
      dispatch(changeScheduleLoading(false));
    }
  };